import { useState } from 'react';

import DefaultOdontologiaView from '../components/SwissMedicalCenterPage/CentrosOdontologicos/DefaultOdontologiaView';
import ChacasOdontoCenter from '../components/SwissMedicalCenterPage/CentrosOdontologicos/ChacasOdontoCenter';
import RecoletaOdontoCenter from '../components/SwissMedicalCenterPage/CentrosOdontologicos/RecoletaOdontoCenter';
import OdontoImplantes from '../components/SwissMedicalCenterPage/CentrosOdontologicos/OdontoImplantes';
import OdontoNeuquen from '../components/SwissMedicalCenterPage/CentrosOdontologicos/OdontoNeuquen';
import OdontoMicrocentro from '../components/SwissMedicalCenterPage/CentrosOdontologicos/OdontoMicrocentro';
import CaballitoOdontoCenter from '../components/SwissMedicalCenterPage/CentrosOdontologicos/CaballitoOdontoCenter';
import SaltaOdontoCenter from '../components/SwissMedicalCenterPage/CentrosOdontologicos/SaltaOdontoCenter';
import CampanaOdontoCenter from '../components/SwissMedicalCenterPage/CentrosOdontologicos/CampanaOdontoCenter';
import ZamoraOdontoCenter from '../components/SwissMedicalCenterPage/CentrosOdontologicos/ZamoraOdontoCenter';

export const useOdontoCenter = () => {
  const [key, setKey] = useState('default');

  const odonto_links = [
    { key: 'default', label: '' },
    { key: 'charcas', label: 'Centro Odontologico Charcas' },
    { key: 'recoleta', label: 'Centro Odontologico Recoleta' },
    { key: 'implantes', label: 'Centro de Implantes' },
    { key: 'neuquen', label: 'Centro Odontologico Neuquen' },
    { key: 'microcentro', label: 'Centro Odontologico Microcentro' },
    { key: 'caballito', label: 'Centro Odontologico Caballito' },
    { key: 'salta', label: 'Centro Odontologico Salta' },
    { key: 'campana', label: 'Centro Odontologico Campana' },
    { key: 'zamora', label: 'Centro Odontologico Lomas de Zamora' },
  ];

  const odonto_components = [
    { eventKey: 'default', comp: <DefaultOdontologiaView /> },
    { eventKey: 'charcas', comp: <ChacasOdontoCenter /> },
    { eventKey: 'recoleta', comp: <RecoletaOdontoCenter /> },
    { eventKey: 'implantes', comp: <OdontoImplantes /> },
    { eventKey: 'neuquen', comp: <OdontoNeuquen /> },
    { eventKey: 'microcentro', comp: <OdontoMicrocentro /> },
    { eventKey: 'caballito', comp: <CaballitoOdontoCenter /> },
    { eventKey: 'salta', comp: <SaltaOdontoCenter /> },
    { eventKey: 'campana', comp: <CampanaOdontoCenter /> },
    { eventKey: 'zamora', comp: <ZamoraOdontoCenter /> },
  ];

  return { odonto_links, odonto_components, key, setKey };
};
